import { render, staticRenderFns } from "./remarkDialog.vue?vue&type=template&id=0e7e8f5a&scoped=true"
import script from "./remarkDialog.vue?vue&type=script&lang=js"
export * from "./remarkDialog.vue?vue&type=script&lang=js"
import style0 from "./remarkDialog.vue?vue&type=style&index=0&id=0e7e8f5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7e8f5a",
  null
  
)

export default component.exports